var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductdisplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    height: 512,
    viewBox: "0 0 48 48",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14 9a4 4 0 1 0 -5 3.86v7.28a4 4 0 0 0 0 7.72v7.28a4 4 0 1 0 2 0v-7.28a4 4 0 0 0 0-7.72v-7.28a4 4 0 0 0 3-3.86zm-6 0a2 2 0 1 1 2 2 2 2 0 0 1 -2-2zm4 30a2 2 0 1 1 -2-2 2 2 0 0 1 2 2zm0-15a2 2 0 1 1 -2-2 2 2 0 0 1 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 6h-23a1 1 0 0 0 0 2h23a1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 12h13a1 1 0 1 0 0-2h-13a1 1 0 0 0 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 37a1 1 0 0 0 -1-1h-23a1 1 0 0 0 0 2h23a1 1 0 0 0 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 40a1 1 0 0 0 0 2h13a1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 21h-23a1 1 0 0 0 0 2h23a1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 27h13a1 1 0 1 0 0-2h-13a1 1 0 0 0 0 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductdisplay);
export default __webpack_public_path__ + "static/media/Product display.79ff3b0ee07a8aa32ad4aa6f18a0c7f4.svg";
export { ForwardRef as ReactComponent };